import React from 'react'
import styled from 'styled-components'

export const VisuallyHidden = React.forwardRef(
  ({ as = 'span', ...props }, ref) => {
    return (
      <Root
        as={as}
        ref={ref}
        {...props}
        style={
          typeof as === 'string'
            ? {
                border: '0',
                clip: 'rect(0 0 0 0)',
                height: '1px',
                margin: '-1px',
                overflow: 'hidden',
                padding: '0',
                position: 'absolute',
                width: '1px',
                whiteSpace: 'nowrap',
                wordWrap: 'normal'
              }
            : null
        }
      />
    )
  }
)

const Root = styled.span``
